export default __webpack_public_path__ + "static/media/walkers.5306ddf9.gif";